module.exports = __webpack_public_path__ + "static/media/LogoWithText.39b27f44.svg";